export enum genreEnum {
  book=38,
  bookSummary=24,
  serial=39,
  podcast=60,
}

//TODO: refactor
export interface IBookShop {
    imageUrl?: string;
    title?: string;
    description?: string;
    actionButton?: IActionButton;
}

export interface IActionButton {
    navigateMod?: number;
    navigateTarget?: string;
    position?: number;
    style?: string;
    icon?: string;
}
export interface IMainPageItem {
    id: string;
    title: string;
    url: string;
    link: any;
    params: Object | any;
    type: string;
    listMode: number | any,
    items: Array<ISliderItem> | any;
    FeaturedListItems: Array<ISliderItem> | any;
    lists: Array<IBestList> | any;
    artistsItems: Array<IArtistList> | any;
}

export interface IMainPageItemResponse {
    displayOrder: number;
    bannerInfo: IMainPageBannerItem | null;
    listInfo: IMainPageSliderItem | null;
}

export interface IMainPageBannerItem {
    title: string;
    imageUrl: string;
    actionValue: string;
    actionType: number | null;
    imageUrlMobile: string;
}

export interface IMainPageSliderItem {
    title: string;
    apiUrl: string;
    listKey: string;
    listMode: number | null;
    items: string;
    lists: any | null;
    artistsItems: any;
    featuredListItems: any;
}

export interface ISliderItem {
    id: number;
    slug: string;
    title: string;
    audioBookId: string;
    recordVersion: string;
}
export class IArtistList {
    constructor(public artist: IArtist,
        public title: string,
        public description: string,
        public featuredItemImageUrl: string) {

    }
}

export class IArtist {
    constructor(public artistId: string,
        public firstName: string,
        public lastName: string,
        public slug: string,
        public artistType: string,
        public artistTypeApiKey: string) {

    }
}

export class IBestList {
    constructor(public apiUrl: string,
        public imageUrl: String,
        public apiListKey: string,
        public title?: string) { }
}
export enum typeSlider {
    artist = 5,
    listCollection = 6,
    featuredList = 7,
    bookCarousel
}

export class IFeatureList {
    constructor(
        public identifier: number,
        public title: string,
        public shortDesc: string,
        public slug: String,
        public image: string,
        public recoredVer:string,
        public genreId:number,
        public customTitle: string,
        public customIcon: string,
        public hasBadge: boolean,
        public badgeTitle?: string,
        public badgePosition?: number,
        public badgeType?: number) { }
}

export class IBookCarousel {
    constructor(
        public title: string,
        public audioBookId: string,
        public productId: string,
        public slug: string,
        public author: string,
        public products: any,
        public disount?: number,
        public identifier?: number,
        public recordVersion?: string,
    ) { }
}
